import { Component, OnInit, Renderer2, AfterViewInit } from '@angular/core';
import { CommonService } from '../../services/common/common.service';
import { WEB_USER_URL } from '../../constants/config';
import { UserService } from '../../services/user/user.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements AfterViewInit {
  currentUser: any = {};
  isCLick: boolean;
  profileName: string = '';

  constructor(private _common: CommonService,
    private _user: UserService,
    private title: Title,
    private router: Router,
    private renderer: Renderer2) {
    this._common.currentUser.subscribe(res => {
      if (localStorage.getItem('CURRENT_USER')) {
        this.profileName = JSON.parse(localStorage.getItem('CURRENT_USER')).first_name + ' ' + JSON.parse(localStorage.getItem('CURRENT_USER')).last_name;
      } else {
        this.profileName = '';
      }
    })
  }

  ngAfterViewInit() {
    $(document).on('click', '.click__toggle__landing', () => {
      this.isCLick && this.openMenu();
    });
    $(document).on('click', '.sublist__item', () => {
      this.isCLick = !this.isCLick;
      this.renderer.removeClass(document.body, 'body__toggole');
    })
    $('.header__item').click((e) => {
      $('.header__item').not(e.currentTarget).removeClass("more-item");
      $(e.currentTarget).toggleClass("more-item");
    })
  }

  ngOnInit() {
    if (localStorage.getItem('CURRENT_USER')) {
      this.profileName = JSON.parse(localStorage.getItem('CURRENT_USER')).first_name + ' ' + JSON.parse(localStorage.getItem('CURRENT_USER')).last_name;
    } else {
      this.profileName = '';
    }
  }

  visitPage(path) {
    window.open(`${WEB_USER_URL}${path}/`, '_blank');
  }

  toggleMenu() {
    $('.header__custom__center').toggleClass('menu__toggle-moblie');
  }

  openMenu() {
    this.isCLick = !this.isCLick;
    this.isCLick ? this.renderer.addClass(document.body, 'body__toggole') : this.renderer.removeClass(document.body, 'body__toggole');
  }

  logout() {
    this._user.logout().then((data) => {
      this.title.setTitle('Tractor Zoom');
      window.open('https://marketing.tractorzoom.com', '_self');
    }).catch((err) => {
      console.log(err);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts